<template>
  <div id="terms">
    <Dialog
      v-model="showDialog"
      :title="$t('Terms.title')"
      max-width="700px"
      custom-class="termsWrap"
      hide-close-button
      persistent
      hide-actions
    >
      <template v-slot:activator="{ on, attrs }">
        <a v-if="!hideTriggerFromRouteSettings && !hideTrigger" v-bind="attrs" v-on="on">{{ $t("Terms.title") }}</a>
      </template>

      <privacy-policy-sheet />

      <term-form @confirm="confirmDialog" :loading="appRequestingData" />
    </Dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "@vue/composition-api"
import { raiseSuccess } from "@/utils/event-bus"
import { UsersModule } from "@/store/users"
import { useWebview } from "@/composable/useWebview"
import router from "@/router"
import PrivacyPolicySheet from "./components/PrivacyPolicySheet.vue"
import Dialog from "@/components/global/Dialog.vue"
import TermForm from "./components/TermForm.vue"
import "./scss/_terms.scss"

export default defineComponent({
  name: "TermsRoot",
  props: {
    hideTrigger: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { appLauncherDetected } = useWebview()
    const showDialog = ref(false)
    const appRequestingData = ref(false)
    const usersStore = UsersModule()

    const shouldForceShowTerms = computed(() => {
      return usersStore.pendingAcceptPrivacyPolicy
    })

    const hideTriggerFromRouteSettings = computed(() => {
      return router.currentRoute.meta?.hideFeedbackSign
    })

    const forceShowTerms = () => {
      if (!appLauncherDetected.value && shouldForceShowTerms.value) {
        showDialog.value = true
      }
    }

    const getDetails = async () => {
      try {
        appRequestingData.value = true

        await usersStore.getMyDetails()
        forceShowTerms()
      } finally {
        appRequestingData.value = false
      }
    }

    const confirmDialog = async () => {
      try {
        appRequestingData.value = true

        await usersStore.acceptTerms()
        showDialog.value = false
        raiseSuccess()
      } finally {
        appRequestingData.value = false
      }
    }

    getDetails()

    return {
      hideTriggerFromRouteSettings,
      showDialog,
      appRequestingData,
      confirmDialog
    }
  },
  components: {
    PrivacyPolicySheet,
    TermForm,
    Dialog
  }
})
</script>
